import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=a3832878&scoped=true&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeExt.vue?vue&type=style&index=0&id=a3832878&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3832878",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a3832878')) {
      api.createRecord('a3832878', component.options)
    } else {
      api.reload('a3832878', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=a3832878&scoped=true&", function () {
      api.rerender('a3832878', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2eWVoLuHXxw8v/JS/comp/DateRangeExt.vue"
export default component.exports